import { escapeHtml } from "../util/common"

const FLASH_CONTAINER_ID = "flash"
const VALID_FLASH_TYPES = ["notice", "warning", "alert"]
const DEFAULT_FLASH_TYPE = "notice"

export default class FlashMessage {
  constructor(message, type = DEFAULT_FLASH_TYPE) {
    this.message = message
    this.type = this.sanitizeType(type)
  }

  show() {
    const container = this.findContainer()
    if (!container) return

    container.innerHTML = this.buildHtml()
  }

  findContainer() {
    return document.getElementById(FLASH_CONTAINER_ID)
  }

  sanitizeType(type) {
    return VALID_FLASH_TYPES.includes(type) ? type : DEFAULT_FLASH_TYPE
  }

  buildHtml() {
    return `
      <div data-controller="flash">
        <div id="toast-default" class="toast-wrapper toast-wrapper--${this.type}" role="alert" data-notifications-target="notification">
          ${escapeHtml(this.message)}
          <button type="button" class="toast-close-btn" data-action="click->flash#remove" aria-label="Close">
            <i class="icon-xmark text-10 toast-close-btn--${this.type}"></i>
            <span class="sr-only">Close</span>
          </button>
        </div>
      </div>
    `
  }
}
